<template>
  <v-container class="user__login-form">
    <div>
      <v-card
        class="d-flex flex-end justify-start mb-2 flex-end"
        flat
        tile
      >
        <v-card
          class="pa-2"
          outlined
        >
        </v-card>

        <v-card 
          class="pa-2"
          outlined
        >
        </v-card>
        </v-card>

        <v-card
          class="d-flex flex-end justify-start mb-2 flex-end"
          flat
          tile
        >
        <v-card
          class="user-profile__back-view plant-details" tile
        >
          <nav-back-component/>
        </v-card>

        <v-card 
          class="elevation-0 d-flex flex-column mb-6"
          outlined
          tile
        >
          <v-card
            class="user__login-form"
            outlined
            tile
          >
            <v-card-title class="fibl-headline form__headline" >
              {{$t('userProfile.headline')}}
            </v-card-title>

            <v-text-field
              class="user__profile decent-input"
              name="name"
              :label="$t('userProfile.name')"
              type="name"
              @blur="updateUserName($event.target.value)" 
              v-model="user.name"
            >
            </v-text-field>

            <v-text-field
              class="user__profile decent-input"
              name="organisation"
              :label="$t('userProfile.organization')"
              type="name"
              @blur="updateUserOrganization($event.target.value)"
              v-model="user.organization"
            >
            </v-text-field>

            <v-divider class="mx-4"></v-divider>

            <v-card-subtitle class="fibl-headline form__subheadline">
              {{$t('userProfile.mail')}}
            </v-card-subtitle>

            <p class = "user__profile_details">{{$t('userProfile.mail_text')}}
              <span 
                style="font-weight: 500 !important;"
              >
              {{user.email}}
              </span>
            </p>
        
            <v-divider class="mx-4"></v-divider>

            <v-row>
              <v-col>
                <v-card-subtitle class="fibl-headline form__subheadline">
                  {{$t('userProfile.password')}}
                </v-card-subtitle>
              </v-col>

              <v-col>
                <div
                  class="password-forgot-user-profile"
                  @click="reset()"
                >
                  {{$t('userProfile.password_reset')}}
                </div>
              </v-col>
            </v-row>
            <v-divider class="mx-4"></v-divider>
    
            <v-card-subtitle
              class="fibl-headline form__subheadline">
              <a
                class="delete-account"
                @click="account_management.action()"
              >
                {{account_management.title}}
              </a>
            </v-card-subtitle>
            <p
              class = "user__profile_details"
            >
              {{$t('userProfile.delete_account_text_1')}}
            </p>
            <p></p>
            <p
              class = "user__profile_details"
            > 
              {{$t('userProfile.delete_account_text_2')}}
            </p>
            <p
              class = "user__profile_details"
            >
            {{$t('userProfile.delete_account_text_3')}}
            </p>
          </v-card>
        </v-card>
      </v-card>
    </div>
  </v-container>
</template>


<script>
import { mapState } from "vuex";
import NavBackComponent from '../components/NavBackComponent.vue';
import * as fb from "@/firebase";

export default {
  name: "UserProfile",

  components: { NavBackComponent },

  computed: {
    ...mapState(["user", "message", "error"]),
  },

  mounted() {
    // store a reference to the component in each menu entry in order to be able to call methods on the component instance
    this.account_management.comp = this;
    if (this.user === undefined | this.user === null) {
      this.$store.dispatch("fetchUserProfile", fb.auth.currentUser.uid);
    }
  },

  data() {
    return {
      register_url: "/user/register",
      reset_url: "/user/reset",
      valid: false,
      showSuccess: true,
      
      account_management : 
        
        {
          title: this.$i18n.t('userProfile.delete_account_title'),
          action: async function() {
            let confirm = await this.comp.$confirm(
              this.comp.$i18n.t('userProfile.dialog_message'),
              {
                color: "#2F6C86",
                title:this.comp.$i18n.t('userProfile.dialog_title'),
                icon: "mdi-delete",
                buttonTrueText: this.comp.$i18n.t('userProfile.dialog_true_button_text'),
                buttonFalseText: this.comp.$i18n.t('userProfile.dialog_false_button_text'),
              }
            );

            if (confirm) {
              this.comp.$store.dispatch("deleteUser");
            }
          },
        },

    };
  },

  methods: {
    deleteAccount() {
      this.$store.dispatch("deleteUser");
    },

    fetchUser() {
      this.$store.dispatch("fetchUserProfile", fb.auth.currentUser.uid);
    },

    updateUserName(val) {
      if(val){
      this.$store.dispatch("updateUserName", {
        name: val
      });}
    },

    updateUserOrganization(val) {
      if (val) {
      this.$store.dispatch("updateUserOrganization", {
        organization: val
      });}
    },

    reset() {
      this.$router.push('/user/reset');
    },
  },
};
</script>
